<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { parseUrl } from '@didi/gpux-utils';
import { v4 as uuidv4 } from 'uuid';
import { runtime, isWxMiniprogram, isAliMiniprogram } from '@/utils/runtime';
import { env } from '@/utils';
import { globalSetOmega} from '@/utils/util';

const traceId = uuidv4();
// eslint-disable-next-line one-var
const queryParams = parseUrl(window.location.href, false);
// eslint-disable-next-line one-var
const GPUX_PAGE_CONFIG = process.env.GPUX_PAGE_CONFIG;

export default {
  name: 'app',
  provide() {
    return {
      Mixin_TraceId: traceId,
      Mixin_Query: parseUrl(window.location.href, false),
      Mixin_Lang: queryParams.lang || this.Mixin_System_Info.lang || 'zh-CN',
      Mixin_City: queryParams.cityId || queryParams.cityid || queryParams.city_id,
    }
  },
  created() {
    console.log('app created', this.Mixin_User_Info)
    let { uid, token } = this.Mixin_User_Info;
    const Mixin_Query = parseUrl(window.location.href, false);
    // eslint-disable-next-line one-var
    const platform = () => {
      if (runtime.is('app')) {
        return 'app';
      } else if (isAliMiniprogram()) {
        return 'aliMini';
      } else if (env.isWechat && !isWxMiniprogram()) {
        return 'wxH5';
      } else if (isWxMiniprogram()) {
        return 'wxMini';
      } else if (runtime.is('quickApp')) {
        return 'quick';
      } else if (runtime.is('kflower')) {
        return 'kflower';
      } else {
        return 'web';
      }
    };
    // 埋点通用参数配置
    globalSetOmega({
      userid: uid,
      sceneid: Mixin_Query.kefuSceneId, // ${string} 客服场景
      tagl1: Mixin_Query.tagL1, // ${string} 路标L1
      tagl2: Mixin_Query.tagL2, // ${string} 路标L2
      cityid: this.Mixin_City || window.city_id_from_location, // ${string} 城市id
      businesstype: Mixin_Query.businessType, // ${string} 客服业务线
      orderid: Mixin_Query.orderId, // ${string} 订单号
      roletype: Mixin_Query.roleType, // ${string} 角色标示，1为乘客，2为司机
      source: Mixin_Query.source, // ${string} 客服模块来源
      traceid: Mixin_Query.traceId || traceId, // ${string} 客服把脉ID
      pagefrom: Mixin_Query.fromPage, // ${string} 客服页面来源
      platform: platform(), // ${String} 平台
      product_line: GPUX_PAGE_CONFIG.extra.biz // {string} 产品线
    });
    this.$omega_dot({
      eventId: 'woater_token_en',
      eventLabel: '获取token'
    });
    // eslint-disable-next-line one-var
    const ticket = token || Mixin_Query.token;
    if (!ticket) {
      this.$omega_dot({
        eventId: 'woater_token_fail_en',
        eventLabel: '获取token失败'
      });
    }
  },
  mounted() {
    const originAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      const wrappedListener = function(...args) {
        // eslint-disable-next-line no-useless-catch
        try {
          return listener.apply(this, args);
        } catch (err) {
          throw err;
        }
      };
      return originAddEventListener.call(this, type, wrappedListener, options);
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">
@import './scss/func.scss';
html,
body,
#app {
  width: 100%;
  height: 100%;
  background-color: #f3f4f5;
  box-sizing: border-box;
}
html,
body {
  /*firefox浏览器*/
  -moz-user-select: text !important;
  /*safari、chrome浏览器*/
  -webkit-user-select: text !important; /*Safari中不支持该属性值，只能使用none或者text，或者是在html的标签属性中使用*/
  /*ie浏览器*/
  -ms-user-select: text !important;
  .cube-popup-content {
    .cube-dialog-main {
      width: px2rem(560);
      border-radius: px2rem(20);
    }
    .cube-dialog-content {
      margin: px2rem(10) auto px2rem(40) auto;
    }
  }
}
.img-toast-component {
  .img-toast-cover {
    height: px2rem(280);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .img-toast-title {
    margin: px2rem(30) auto;
    margin-top: px2rem(48);
    font-size: px2rem(40);
    line-height: px2rem(56);
    font-weight: bolder;
    color: #000000;
  }
  &.img-toast-content {
    color: #444444;
    word-break: break-all;
    padding: 0 px2rem(40);
    font-size: px2rem(28);
  }
}

.radio-box {
  .cube-radio-wrap {
    padding: 0;
  }

  .border-bottom-1px:after {
    border-bottom: none;
  }
}
</style>
